import React from "react";
import API from "../../Services/API";
import { toast } from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import { useNavigate } from "react-router-dom";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { HiOutlineQrcode } from "react-icons/hi";
import { TbBuildingStore } from "react-icons/tb";
import { BsCalendar4Week, BsSearch, BsInfoSquare } from "react-icons/bs";
import moment from "moment-jalaali";
const PROCESS_FOR = "Sales"; // یا "Vendors"

const toEnDigits = (s) =>
    String(s || "")
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
        .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
        .trim();

function ReturnRequestCreate() {
    const navigate = useNavigate();
    const [isLoaded, setIsLoaded] = React.useState(true);
    const [factorNumber, setFactorNumber] = React.useState("");
    const [order, setOrder] = React.useState(null);
    const [form, setForm] = React.useState({
        failure_reason: "",
        voltage: "",
        service_type: "",
        other_description: "",
    });

    const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const onSearch = (e) => {
        e.preventDefault();
        const factor = toEnDigits(factorNumber);
        if (!factor) {
            toast.error("شماره فاکتور را وارد کنید.");
            return;
        }
        setIsLoaded(false);
        setOrder(null);
        API.searchReturnOrder({ factor_number: factor, processFor: PROCESS_FOR })            .then((response) => {
                setOrder(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {
                toast.error(error.response ? error.response.data.message : error.message);
                setIsLoaded(true);
            });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (!order) return;
        if (!form.failure_reason.trim() || !form.voltage.trim() || !form.service_type.trim()) {
            toast.error("علت خرابی، ولتاژ و نوع خدمات الزامی است.");
            return;
        }
        setIsLoaded(false);
        API.storeReturnRequest({
            order_id: order.order_id,
            processFor: PROCESS_FOR,
            ...form,
            voltage: toEnDigits(form.voltage),
        })
            .then((response) => {
                toast.success(response.message);
                setTimeout(() => navigate("/return-requests"), 1500);
            })
            .catch((error) => {
                toast.error(error.response ? error.response.data.message : error.message);
                setIsLoaded(true);
            });
    };

    return (
        <React.Fragment>
            <Header />
            <Navbar page="upsorders" public={1} />
            <Toast />
            {!isLoaded && <Loading />}
            <main id="main" className="main rtl">
                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <AiOutlineAppstoreAdd className="ms-2" />
                        ثبت مرجوعی از طرف نماینده UPS
                    </h1>
                </div>

                <section className="section">
                    <div className="row">
                        {/* ---- جستجوی فاکتور ---- */}
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body pt-4">
                                    <form onSubmit={onSearch} className="row g-2 align-items-center">
                                        <div className="form-floating col-9 col-md-10">
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                className="form-control px-5 text-left"
                                                id="factorNumber"
                                                placeholder="شماره فاکتور"
                                                value={factorNumber}
                                                onChange={(e) => setFactorNumber(e.target.value)}
                                            />
                                            <label htmlFor="factorNumber" className="right-0">شماره فاکتور</label>
                                        </div>
                                        <div className="col-3 col-md-2">
                                            <button type="submit" className="btn btn-primary w-100 p-3 text-small-2" disabled={!isLoaded}>
                                                <BsSearch className="ms-1" /> جستجو
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        {order && (
                            <form onSubmit={onSubmit}>
                                {/* ---- مشخصات فاکتور ---- */}
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row mx-2 mb-3 border-bottom pb-2 pt-5">
                                                <div className="col-1"><TbBuildingStore /></div>
                                                <div className="col-5 text-small-2">نماینده</div>
                                                <div className="col-6 text-start fw-bold text-small-2">
                                                    {order.vendor?.title}&nbsp;{order.vendor?.city}
                                                </div>
                                            </div>
                                            <div className="row mx-2 mb-3 border-bottom pb-2">
                                                <div className="col-1"><HiOutlineQrcode /></div>
                                                <div className="col-5 text-small-2">شماره فاکتور</div>
                                                <div className="col-6 text-start fw-bold text-small-2">{order.factor_number}</div>
                                            </div>
                                            <div className="row mx-2 mb-3 border-bottom pb-2">
                                                <div className="col-1"><BsInfoSquare /></div>
                                                <div className="col-5 text-small-2">تعداد باتری فاکتور</div>
                                                <div className="col-6 text-start fw-bold text-small-2">
                                                    {order.battery_qty}
                                                    {order.scanned_count > 0 && (
                                                        <span className="text-muted fw-normal"> ({order.scanned_count} ردیف ثبت‌شده)</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="row mx-2 mb-3 pb-2">
                                                <div className="col-1"><BsCalendar4Week /></div>
                                                <div className="col-5 text-small-2">تاریخ سفارش</div>
                                                <div className="col-6 text-start fw-bold text-small-2">
                                                    {order.created_at && moment(order.created_at).format("jYYYY/jMM/jDD HH:mm")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ---- فیلدهای توضیحی ---- */}
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-header text-end text-small-2">اطلاعات مرجوعی</div>
                                        <div className="card-body">
                                            <div className="row mx-2 mt-2">
                                                <div className="form-floating col-12 mt-4">
                          <textarea
                              className="form-control px-5"
                              style={{ height: "100px" }}
                              id="failure_reason"
                              name="failure_reason"
                              placeholder="علت خرابی"
                              value={form.failure_reason}
                              onChange={onChange}
                          />
                                                    <label htmlFor="failure_reason" className="right-0">علت خرابی</label>
                                                </div>

                                                <div className="form-floating col-md-6 mt-4">
                                                    <input
                                                        type="text"
                                                        className="form-control px-5 text-left"
                                                        id="voltage"
                                                        name="voltage"
                                                        placeholder="ولتاژ"
                                                        value={form.voltage}
                                                        onChange={onChange}
                                                    />
                                                    <label htmlFor="voltage" className="right-0">ولتاژ</label>
                                                </div>

                                                <div className="form-floating col-12 mt-4">
                          <textarea
                              className="form-control px-5"
                              style={{ height: "100px" }}
                              id="service_type"
                              name="service_type"
                              placeholder="نوع خدمات"
                              value={form.service_type}
                              onChange={onChange}
                          />
                                                    <label htmlFor="service_type" className="right-0">نوع خدمات</label>
                                                </div>

                                                <div className="form-floating col-12 mt-4">
                          <textarea
                              className="form-control px-5"
                              style={{ height: "100px" }}
                              id="other_description"
                              name="other_description"
                              placeholder="سایر توضیحات"
                              value={form.other_description}
                              onChange={onChange}
                          />
                                                    <label htmlFor="other_description" className="right-0">سایر توضیحات</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ---- لیست باتری‌های سفارش (همان جدول OrderDetails) ---- */}
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-header text-end text-small-2">لیست باتری‌های سفارش</div>
                                        <div className="card-footer text-body-secondary">
                                            {order.batteries?.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table table-striped text-small-2">
                                                        <thead className="text-center">
                                                        <tr>
                                                            <th scope="col">#</th>
                                                            <th scope="col">برند</th>
                                                            <th scope="col">آمپراژ</th>
                                                            <th scope="col">نوع</th>
                                                            <th scope="col">تعداد</th>
                                                            <th scope="col">توضیحات</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody className="text-center">
                                                        {order.batteries.map((cart, index) => (
                                                            <tr key={index}>
                                                                <th scope="row">{index + 1}</th>
                                                                <td>{cart.brand}</td>
                                                                <td>{cart.amperage}</td>
                                                                <td>{cart.batteryType}</td>
                                                                <td>{cart.count}</td>
                                                                <td>{cart.batteryDescription}</td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div className="text-center text-muted text-small-2 py-3">باتری‌ای برای این فاکتور ثبت نشده است.</div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 mt-2 mb-5">
                                    <button type="submit" className="btn btn-primary w-100 p-3 text-small-2" disabled={!isLoaded}>
                                        ثبت درخواست مرجوعی
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </section>
            </main>
        </React.Fragment>
    );
}

export default ReturnRequestCreate;